<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div  v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('BatteryFile.batteryNumber')">
                    <el-input
                      size="mini"
                      v-model="formInline.batteryNumber"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.carId')">
                    <el-input
                      size="mini"
                      v-model="formInline.carId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.terminalId')">
                    <el-input
                      size="mini"
                      v-model="formInline.terminalId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('BatteryStatus.batteryState')">
                    <el-select
                      v-model="formInline.batteryState"
                      :placeholder="$t('BatteryStatus.form.batteryState')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in stateList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('BatteryStatus.isWarning')">
                    <el-select
                      v-model="formInline.batteryWarning"
                      :placeholder="$t('BatteryStatus.isWarning')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in warnList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button v-if="isPrimaryKey('BATTERYSTATUS_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="1148px"
        :visible.sync="dialogFormVisible"
        :title="$t('common.btn.operate')"
        class="bombDialong"
        :close-on-click-modal="false"
      >
        <div class="allDialong">
          <div class="carImg">
            <div>{{$t('BatteryFile.batteryNumber')}}</div>
            <div>{{ batteryNumber }}</div>
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="$t('BatteryStatus.batteryInform')" name="first" lazy>
              <BatteryInfo
                :bind-battery="batteryNumber"
                ref="batteryInfo"
              ></BatteryInfo>
            </el-tab-pane>
            <el-tab-pane :label="$t('BatteryStatus.chargeAndDischargeRecord')" name="second" lazy>
              <ChargingRecord
                :bind-battery="batteryNumber"
                ref="chargingRecord"
              ></ChargingRecord>
            </el-tab-pane>
            <el-tab-pane :label="$t('BatteryStatus.batteryVoltageRecord')" name="third" lazy>
              <VoltageRecord
                :bind-battery="batteryNumber"
                ref="voltageRecord"
              ></VoltageRecord>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import BatteryStatus from "./BatteryStatus.js";
export default BatteryStatus;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>

